import { SiteInfo } from './site-info.model';
import { AccessScope } from '../access-scopes.model';
export class Menu {
  name: string;
  route: string;
  subMenus: SubMenu[];
}

export class SubMenu {
  name: string;
  route: string;
}

export class Markup {
  markupType: string;
  markupDollar: number;
  markupMultiplier: number;
  markupDisabled: boolean;

  constructor() {
    this.markupType = 'multiplier';
    this.markupMultiplier = 2;
    this.markupDollar = 100;
    this.markupDisabled = false;
  }
}

export class UserResponse {
  authenticated: boolean;
  applicationId: string;
  applicationName: string;
  cmsDealerNumber: string;
  isTempPassword: string;
  compliance: boolean;
  complianceId: string;
  cancellationURL: string;
  programId: string;
  userName: string;
  fullName: string;
  emailId: string;
  languageCode: string;
  languageId: string;
  displayProblem: boolean;
  availableProductText: AvailableProductText;
  defaultGetProduct: string;
  defaultSaveProduct: string;
  name: string;
  status: boolean;
  message: string;
  token: string;
  availableProducts: AvailableProduct[];
  dealerInfo: DealerInfo;
  siteInfo: SiteInfo;
  roles: string[];
  roleIds: string[];
  pendingDays: PendingDays;
  pendingContracts: number;
  menus: Menu[];
  userDefaults: { markup: Markup };
  isRelatedDealer: boolean;
  aggregatorURL: string;
  aggregateService?: boolean;
  productCategory: any;
  disableSaveQuote: boolean;
  relatedApplicationId: string;
  allDealers: AllDealers[];
  useDealerGroup: boolean;
  actualDealerGroup: string;
  resourceView: string;
  scopes: AccessScope[];

  constructor() {
    this.userDefaults = {
      markup: new Markup(),
    };
  }
}

export class AllDealers {
  cmsDealerNumber: string;
  programId: string;
  applicationId: string;
  source: string;
  programMake: string;
  vendor: string;
  dealerId: string;
}

export class DealerInfo {
  dealerAddress1: string;
  dealerCity: string;
  dealerId: string;
  dealerFullName: string;
  dealerName: string;
  dealerPhone: string;
  dealerState: string;
  dealerZipCode: string;
  stateId: string;
}

export class AvailableProduct {
  productCode: string;
  ProductDescription: string;
  productType: string;
  productTypeDescription: string;
  imageId: string;
  productCategory: string;
}

export class AvailableProductText {
  status: boolean;
  translation: AvailableProductTextTranslation;
}

export class AvailableProductTextTranslation {
  displayName: string;
  links: AvailableProductTextLinks[];
  summary: string;
}

export class AvailableProductTextLinks {
  id: string;
  link: string;
  linkTitle: string;
  showMore: boolean;
  paragraphText: string;
  productCategory: string;
  type: string;
}
export class PendingDays {
  checkPendingDays: CheckPendingDays[];
  disableRegister: boolean;
  disableRegisterDays: number;
  disableRegisterRangeTagCode: string;
  enableHardStop: boolean;
}
export class CheckPendingDays {
  count: number;
  rangeMin: number;
  rangeMax: number;
  rangeTagCode: string;
  rangeTagMessage: string;
  loginMessage: string;
  rangeExceeded: boolean;
}
